import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class CustomerValidationConfig {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getAnnualValidationNotificationEnabled(): boolean {
		return this.configService.get((x) => x.common.annualValidation?.isEnabled, false);
	}

	getDocumentValidationNotificationEnabled(): boolean {
		return this.configService.get((x) => x.common.documentValidation?.isEnabled, false);
	}
}
